import {Parser} from 'htmlparser2';
import {isLetter} from '../helper/isLetter';

const relativeTimeHtml = state => {
  let ch, max, pos = state.pos;

  max = state.posMax;
  if (state.src.charCodeAt(pos) !== 0x3C/* < */ || pos + 2 >= max) {
    return false;
  }

  // Quick fail on second char
  ch = state.src.charCodeAt(pos + 1);
  if (!isLetter(ch)) {
    return false;
  }

  const relativeTime = {
    start: null,
    end: null,
  };

  const parser = new Parser({
    onopentag(name, attributes, isImplied) {
      if (name === 'relative-time') {
        if (!relativeTime.start) {
          relativeTime.start = {
            startIndex: parser.startIndex,
            endIndex: parser.endIndex,
          };
          relativeTime.datetime = attributes['datetime'];
          relativeTime.format = attributes['format'];
          relativeTime.hour = attributes['hour'];
          relativeTime.minute = attributes['minute'];
          relativeTime.second = attributes['second'];
        }
      }
    },
    onclosetag(name, isImplied) {
      if (name === 'relative-time') {
        if (!relativeTime.end) {
          relativeTime.end = {
            startIndex: parser.startIndex,
            endIndex: parser.endIndex,
          };
        }
      }
    },
  });

  parser.write(state.src.slice(pos));

  if ((!relativeTime.start || relativeTime.start.startIndex > 0) || !relativeTime.end) {
    return false;
  }

  const token = state.push('relative_time_open', 'relative-time', 1);
  token.attrs = [
      ['datetime', relativeTime.datetime],
      ['format', relativeTime.format],
      ['hour', relativeTime.hour],
      ['minute', relativeTime.minute],
      ['second', relativeTime.second]
  ];

  state.pos = pos + relativeTime.start.endIndex + 1;
  state.posMax = pos + relativeTime.end.startIndex;

  state.md.inline.tokenize(state);

  state.push('relative_time_close', 'relative-time', -1);

  state.pos = pos + relativeTime.end.endIndex + 1;
  state.posMax = max;

  return true;
};

export const markdownRelativeTime = md => md.inline.ruler.before('link',
    'relative_time', relativeTimeHtml);